import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { RecommendationSuccessResultCreator } from '../index';
export var RecommendationsRequestBroker = /*#__PURE__*/function () {
  function RecommendationsRequestBroker() {
    _classCallCheck(this, RecommendationsRequestBroker);
  }
  _createClass(RecommendationsRequestBroker, [{
    key: "extract",
    value: function extract(response) {
      var _response$recommendat, _response$recommendat2;
      return (_response$recommendat = response === null || response === void 0 || (_response$recommendat2 = response.recommendations) === null || _response$recommendat2 === void 0 ? void 0 : _response$recommendat2.data) !== null && _response$recommendat !== void 0 ? _response$recommendat : [];
    }
  }, {
    key: "getSuccessResultCreator",
    value: function getSuccessResultCreator(response, result) {
      return new RecommendationSuccessResultCreator(response, result);
    }
  }]);
  return RecommendationsRequestBroker;
}();